module.exports = ".align-buttons {\n  text-align: right; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-update-profile/master-update-profile.component.scss
// module id = ./src/app/master/master-update-profile/master-update-profile.component.scss
// module chunks = main